import { z } from 'zod';

export const TextComponentColor = z.enum(['black', 'blue', 'purple']);
export type TextComponentColor = z.infer<typeof TextComponentColor>;

export const TextComponent = z.object({
  text: z.string(),
  tooltip: z.string().optional(),
  color: TextComponentColor.optional(),
  isBold: z.boolean().optional(),
  isSuperscript: z.boolean().optional(),
  isDottedUnderline: z.boolean().optional(),
  truncationGroupRunCount: z.number().optional(),
});

export type TextComponent = z.infer<typeof TextComponent>;

export const readableTextComponents = (components: TextComponent[]) => {
  return components.map((component) => component.text).join('');
};
